import { defineMessages } from "react-intl";
const messages = defineMessages({
    commuteTitle: {
        id: "app.aiDiscoverability.customSubtopics.commuteTab.commute.title",
        defaultMessage: "Commute",
    },
    commuteSubtitle: {
        id: "app.aiDiscoverability.customSubtopics.commuteTab.commute.subtitle",
        defaultMessage: 'How these are used: "Apartments that are [20] minutes by [subway] to [Times Square]"',
    },
});
export default messages;
